module.exports = __webpack_public_path__ + "img/missionaries24_2019_7-7-2021.f09d5677.jpg";